export default __webpack_public_path__ + "static/compactadores-95c8e3ef559477bc15a583a5e4a1bd5b.png";